<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-button
        @click.native="$modal.show('create-staff-cars-modal')"
        size="small"
        theme="info"
      >
        Archive transfer
      </app-button>
      <app-cells>
        <app-date-picker
          @input="onRangeChange"
          v-model="date_range"
          placeholder="Transfer date"
          class="datepicker--220"
          :clearable="false"
          range
        />
        <app-input
          @input.native="onTransferSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by group name"
          name="search"
        />
        <app-select
          @input="fetchItems"
          v-model="filter_car"
          :reduce="item => item.id"
          :options="cars_options"
          :display-field="option => `${option.car_model.name} ${option.plate_number ? `(${option.plate_number})` : ''}` "
          label="plate_number"
          placeholder="Select car"
          class="select--300"
        />
        <app-select
          @input="fetchItems"
          v-model="filter_driver"
          :reduce="item => item.id"
          :options="drivers_options"
          label="full_name"
          placeholder="Enter driver"
          class="select--300"
        />
      </app-cells>
      <template v-if="archive_transfers.length">
        <div v-for="transfer_item in archive_transfers" :key="`archive_${transfer_item.name}`" style="margin-bottom: 30px">
          <app-cells v-if="transfer_item.name" class="sticky-title">
            <h2 class="title">{{ transfer_item.name }}</h2>
            <div v-if="transfer_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
          </app-cells>
          <div class="transfer-list">
            <transfers-blocks
              v-for="(transfer, index) in transfer_item.items"
              :key="transfer.id"
              @onArrangePopupOpen="onArrangePopupOpen"
              :transfer="transfer"
              :count="index + 1"
              :lazy_details="true"
              :is_show_arrange_button="true"
              :is_show_edit_cancel_buttons="false"
            />
          </div>
        </div>
        <app-cells position="between">
          <div>
            <paginate
                :clickHandler="onClickPagination"
                v-if="pagination.pages > 1"
                v-model="pagination.page"
                :page-count="pagination.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" />
        </app-cells>
      </template>
      <modal
        name="create-staff-cars-modal"
        :width="1400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        draggable=".popup__title"
        :reset="true"
        class="modal-not-overflow"
      >
        <div class="popup">
          <button @click="$modal.hide('create-staff-cars-modal')" class="popup__close" type="button"></button>
          <div class="popup__title">Add archive transfer</div>
          <div v-if="create_staff_cars_form" class="popup__body">
            <form @submit.prevent="onCheckCreateStaffCarsForm">
              <div class="arrival-popup">
                <app-grid>
                  <template #item-1>
                    <app-form-group label="Name" label-for="tr_name" required>
                      <app-input
                        v-model="create_staff_cars_form.name"
                        placeholder="Name"
                        id="name"
                        name="tr_name"
                        :error="$v.create_staff_cars_form.name.$error"
                      />
                      <template #error>
                        <div v-if="$v.create_staff_cars_form.name.$dirty && !$v.create_staff_cars_form.name.required">Required field</div>
                      </template>
                    </app-form-group>
                    <app-form-group label="Pick-up point" required>
                      <app-select
                        @input="onStaffPickUpPointSelected(create_staff_cars_form.pick_up_point, 'create_staff_cars_form', 'create_staff_cars_submit')"
                        @search="onLocationSearch"
                        v-model="create_staff_cars_form.pick_up_point"
                        :options="location_options"
                        :filterable="false"
                        :clearable="false"
                        placeholder="Select"
                        :error="$v.create_staff_cars_form.pick_up_point.$error"
                      />
                      <template #error>
                        <div v-if="$v.create_staff_cars_form.pick_up_point.$dirty && !$v.create_staff_cars_form.pick_up_point.required">Required field</div>
                      </template>
                    </app-form-group>
                    <app-form-group label="Pax" label-for="pax" required>
                      <app-input
                        v-model.number="create_staff_cars_form.other_pax"
                        placeholder="Pax"
                        id="pax-time"
                        name="pax"
                        type="number"
                        :error="$v.create_staff_cars_form.other_pax.$error"
                      />
                      <template #error>
                        <div v-if="$v.create_staff_cars_form.other_pax.$dirty && !$v.create_staff_cars_form.other_pax.required">Required field</div>
                      </template>
                    </app-form-group>
                    <app-grid>
                      <template #item-1>
                        <app-form-group label="Pick-up date" required>
                          <app-date-picker
                            v-model="create_staff_cars_form.pick_up_date"
                            placeholder="Specify a date"
                            :error="$v.create_staff_cars_form.pick_up_date.$error"
                          />
                          <template #error>
                            <div v-if="$v.create_staff_cars_form.pick_up_date.$dirty && !$v.create_staff_cars_form.pick_up_date.required">Required field</div>
                          </template>
                        </app-form-group>
                      </template>
                      <template #item-2>
                        <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                          <app-input
                            v-model="create_staff_cars_form.pick_up_time"
                            v-mask="'99:99'"
                            placeholder="Time"
                            autocomplete="off"
                            id="pick_up_time-time"
                            name="pick_up_time"
                            @paste.native.prevent
                            :error="$v.create_staff_cars_form.pick_up_time.$error"
                          />
                          <template #error>
                            <div v-if="$v.create_staff_cars_form.pick_up_time.$dirty && !$v.create_staff_cars_form.pick_up_time.required">Required field</div>
                            <div v-if="$v.create_staff_cars_form.pick_up_time.$dirty && !$v.create_staff_cars_form.pick_up_time.timeRegex">Wrong time</div>
                          </template>
                        </app-form-group>
                      </template>
                    </app-grid>
                    <draggable
                      :list="create_staff_cars_form.points"
                      v-bind="dragOptions"
                      handle=".sortable__handle"
                      class="transfer-sortable transfer-sortable--lite"
                    >
                      <transition-group type="transition" :name="'flip-list'" tag="div">
                        <div v-for="(element, index) in create_staff_cars_form.points" :key="`create_staff_points_${index}`" class="transfer-sortable__item">
                          <div class="transfer-sortable__row">
                            <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                              <app-select
                                @input="onStaffLocationSelected(element.location, index, 'create_staff_cars_form', 'create_staff_cars_submit')"
                                @search="onLocationSearch"
                                v-model="element.location"
                                :options="location_options"
                                :filterable="false"
                                :clearable="false"
                                placeholder="Select"
                                :error="$v.create_staff_cars_form.points.$each[index].location.$error"
                              />
                              <template #error>
                                <div v-if="$v.create_staff_cars_form.points.$each[index].location.$dirty && !$v.create_staff_cars_form.points.$each[index].location.required">Required field</div>
                              </template>
                            </app-form-group>
                            <button type="button" class="transfer-sortable__btn sortable__handle">
                              <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                            </button>
                            <button
                              v-if="index !== 0"
                              @click="onRemoveStaffDestination(index, 'create_staff_cars_form')"
                              class="transfer-sortable__close"
                              type="button"
                            >
                              <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                            </button>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                    <app-cells>
                      <app-button @click.native="onAddStaffDestination('create_staff_cars_form')" size="small">
                        <img src="@/assets/img/plus-icon.svg" alt="Add">
                        <span>Add destination</span>
                      </app-button>
                    </app-cells>
                  </template>
                  <template #item-2>
                    <div class="arrange-popup">
                      <div class="arrange-popup__subtitle">Transport</div>
                      <div class="arrange-popup__part">
                        <div class="arrange-popup__block-title">
                          <span>Own cars</span>
                          <button @click="onAddOwnCar('create_staff_cars_form')" type="button">
                            <img src="@/assets/img/add-big-button-icon.svg" alt="">
                          </button>
                        </div>
                        <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                          <div v-for="(element, index) in create_staff_cars_form.own_cars" :key="`own_item_${index}`" class="transfer-sortable__item">
                            <div class="transfer-sortable__row transfer-sortable__row--pr">
                              <app-form-group class="form-group--no-indent" required>
                                <app-select
                                  @input="onOwnCarSelected(element.car, index, 'create_staff_cars_form')"
                                  v-model="element.car"
                                  :options="cars_options"
                                  :clearable="false"
                                  label="plate_number"
                                  placeholder="Select car"
                                  :error="$v.create_staff_cars_form.own_cars.$each[index].car.$error"
                                />
                                <template #error>
                                  <div v-if="$v.create_staff_cars_form.own_cars.$each[index].car.$dirty && !$v.create_staff_cars_form.own_cars.$each[index].car.required">Required field</div>
                                </template>
                              </app-form-group>
                              <app-form-group class="form-group--no-indent" required>
                                <app-select
                                  v-model="element.driver"
                                  :options="drivers_options"
                                  :clearable="false"
                                  label="full_name"
                                  placeholder="Enter driver"
                                  class="select"
                                  :error="$v.create_staff_cars_form.own_cars.$each[index].driver.$error"
                                />
                                <template #error>
                                  <div v-if="$v.create_staff_cars_form.own_cars.$each[index].driver.$dirty && !$v.create_staff_cars_form.own_cars.$each[index].driver.required">Required field</div>
                                </template>
                              </app-form-group>
                              <button
                                @click="onRemoveOwnItem(index, 'create_staff_cars_form')"
                                class="transfer-sortable__close"
                                type="button"
                              >
                                <img src="@/assets/img/delete-transfer.svg" alt="">
                              </button>
                            </div>
                            <div class="transfer-sortable__row">
                              <app-cells :indent="false">
                                Driver confirmed: <app-switcher v-model="element.driver_confirmed" :readonly="!element.driver" />
                              </app-cells>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="arrange-popup__part">
                        <div class="arrange-popup__block-title">
                          <span>Rental</span>
                          <button @click="onAddRental('create_staff_cars_form')" type="button">
                            <img src="@/assets/img/add-big-button-icon.svg" alt="">
                          </button>
                        </div>
                        <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                          <div v-for="(element, index) in create_staff_cars_form.rental_cars" :key="`rental_item_${index}`" class="transfer-sortable__item">
                            <div class="transfer-sortable__row transfer-sortable__row--pr">
                              <app-form-group class="form-group--no-indent" required>
                                <app-select
                                  @input="onRentalCompanySelected(element.rental_company, index)"
                                  v-model="element.rental_company"
                                  :options="company_options"
                                  :clearable="false"
                                  placeholder="Select company"
                                  :error="$v.create_staff_cars_form.rental_cars.$each[index].rental_company.$error"
                                />
                                <template #error>
                                  <div v-if="$v.create_staff_cars_form.rental_cars.$each[index].rental_company.$dirty && !$v.create_staff_cars_form.rental_cars.$each[index].rental_company.required">Required field</div>
                                </template>
                              </app-form-group>
                              <app-form-group class="form-group--no-indent" required>
                                <app-select
                                  @input="onRentalCarModelSelected(element.car_model.id, index, 'create_staff_cars_form')"
                                  v-model="element.car_model"
                                  :options="rental_options[index].models_options"
                                  :clearable="false"
                                  placeholder="Select car model"
                                  :readonly="!element.rental_company"
                                  :error="$v.create_staff_cars_form.rental_cars.$each[index].car_model.$error"
                                />
                                <template #error>
                                  <div v-if="$v.create_staff_cars_form.rental_cars.$each[index].car_model.$dirty && !$v.create_staff_cars_form.rental_cars.$each[index].car_model.required">Required field</div>
                                </template>
                              </app-form-group>
                            </div>
                            <div class="transfer-sortable__row transfer-sortable__row--mix transfer-sortable__row--pr">
                              <app-form-group class="form-group--no-indent" required>
                                <app-select
                                  @input="onRentalCarSelected(element.car, index, 'create_staff_cars_form')"
                                  v-model="element.car"
                                  :options="rental_options[index].cars_options"
                                  :clearable="false"
                                  label="plate_number"
                                  placeholder="Select car"
                                  :readonly="!element.car_model"
                                />
                              </app-form-group>
                              <app-form-group class="form-group--no-indent" required>
                                <app-select
                                  v-model="element.driver"
                                  :options="rental_options[index].drivers_options"
                                  :clearable="false"
                                  label="full_name"
                                  placeholder="Select driver"
                                  :readonly="!element.car"
                                />
                              </app-form-group>
                              <div class="arrange-popup__cost">
                                <span>Price (TSh):</span>
                                <app-form-group class="form-group--no-indent">
                                  <app-input
                                    v-model.number="element.rental_cost"
                                    type="number"
                                    placeholder="0"
                                    id="cost"
                                    name="cost"
                                    class="input--100"
                                    :error="$v.create_staff_cars_form.rental_cars.$each[index].rental_cost.$error"
                                  />
                                  <template #error>
                                    <div v-if="$v.create_staff_cars_form.rental_cars.$each[index].rental_cost.$dirty && !$v.create_staff_cars_form.rental_cars.$each[index].rental_cost.required">Required field</div>
                                  </template>
                                </app-form-group>
                              </div>
                            </div>
                            <button
                              @click="onRemoveRentalItem(index, 'create_staff_cars_form')"
                              class="transfer-sortable__close"
                              type="button"
                            >
                              <img src="@/assets/img/delete-transfer.svg" alt="">
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="arrange-popup__part">
                        <div class="arrange-popup__block-title">
                          <span>Taxi</span>
                          <button @click="onAddTaxi('create_staff_cars_form')" type="button">
                            <img src="@/assets/img/add-big-button-icon.svg" alt="">
                          </button>
                        </div>
                        <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                          <div v-for="(element, index) in create_staff_cars_form.taxi" :key="`taxi_item_${index}`" class="transfer-sortable__item">
                            <div class="transfer-sortable__row transfer-sortable__row--mix transfer-sortable__row--pr">
                              <app-form-group class="form-group--no-indent" required>
                                <app-select
                                  v-model="element.taxi_driver"
                                  :options="taxi_options"
                                  :clearable="false"
                                  label="full_name"
                                  placeholder="Select taxi"
                                  :error="$v.create_staff_cars_form.taxi.$each[index].taxi_driver.$error"
                                />
                                <template #error>
                                  <div v-if="$v.create_staff_cars_form.taxi.$each[index].taxi_driver.$dirty && !$v.create_staff_cars_form.taxi.$each[index].taxi_driver.required">Required field</div>
                                </template>
                              </app-form-group>
                              <span v-if="element.taxi_driver">
                              {{ element.taxi_driver.car_model.name }} ({{ element.taxi_driver.plate_number }})
                            </span>
                              <div class="arrange-popup__cost">
                                <span>Price (TSh):</span>
                                <app-form-group class="form-group--no-indent">
                                  <app-input
                                    v-model.number="element.cost"
                                    type="number"
                                    placeholder="0"
                                    id="cost"
                                    name="cost"
                                    class="input--100"
                                    :error="$v.create_staff_cars_form.taxi.$each[index].cost.$error"
                                  />
                                  <template #error>
                                    <div v-if="$v.create_staff_cars_form.taxi.$each[index].cost.$dirty && !$v.create_staff_cars_form.taxi.$each[index].cost.required">Required field</div>
                                  </template>
                                </app-form-group>
                              </div>
                              <button
                                @click="onRemoveTaxiItem(index, 'create_staff_cars_form')"
                                class="transfer-sortable__close"
                                type="button"
                              >
                                <img src="@/assets/img/delete-transfer.svg" alt="">
                              </button>
                            </div>
                            <div class="transfer-sortable__row">
                              <app-cells :indent="false">
                                Driver confirmed: <app-switcher v-model="element.driver_confirmed" :readonly="!element.taxi_driver" />
                              </app-cells>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </app-grid>
                <app-form-group label="Notes" label-for="notes" required>
                  <app-textarea
                    v-model="create_staff_cars_form.notes"
                    id="notes"
                    placeholder="Notes"
                    :error="$v.create_staff_cars_form.notes.$error"
                  />
                  <template #error>
                    <div v-if="$v.create_staff_cars_form.notes.$dirty && !$v.create_staff_cars_form.notes.required">Required field</div>
                  </template>
                </app-form-group>
              </div>
              <app-cells position="center" :indent="false">
                <app-button type="submit" ref="create_staff_cars_submit">Request transfer</app-button>
              </app-cells>
            </form>
          </div>
        </div>
      </modal>
      <modal
        name="arrange-popup"
        :width="1400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
      >
        <div class="popup">
          <button @click="$modal.hide('arrange-popup')" class="popup__close" type="button"></button>
          <div class="popup__title">Arrange transfer</div>
          <div v-if="transfer" class="popup__body">
            <form @submit.prevent="onCheckArrangeForm">
              <div class="arrange-popup">
                <app-grid>
                  <template #item-1>
                    <div class="arrange-popup__name">{{ transfer.name }} - {{ transfer.pax }} Pax</div>
                    <div v-if="transfer.status.code === 'need_amended'" class="arrange-popup__before">
                      <div class="before-info">
                        <div class="before-info__title">Before changes:</div>
                        <div class="before-info__wrapper">
                          <div v-if="transfer.amended_data.pax" class="before-info__row">
                            <span>Pax:</span>
                            <span>{{ transfer.amended_data.pax }}</span>
                          </div>
                          <div v-if="transfer.amended_data.pick_up_date" class="before-info__row">
                            <span>Pick-up date:</span>
                            <span>{{ dateFormat(transfer.amended_data.pick_up_date) }}</span>
                          </div>
                          <div v-if="transfer.amended_data.pick_up_time" class="before-info__row">
                            <span>Pick-up time:</span>
                            <span>{{ transfer.amended_data.pick_up_time }}</span>
                          </div>
                        </div>
                        <div v-if="transfer.amended_data.pick_up_point" class="before-info__row">
                          <span>Pick-up point:</span>
                          <span>{{ transfer.pick_up_point.short_name }}</span>
                        </div>
                        <div class="before-info__row">
                          <span>Points:</span>
                          <span class="before-info__points">
                          <span v-for="(point, index) in transfer.amended_data.points" :key="point.id" class="before-info__point">
                            {{ point.location }}
                            <img v-if="index !== transfer.amended_data.points.length - 1" src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                          </span>
                        </span>
                        </div>
                      </div>
                    </div>
                    <div class="arrange-popup__points">
                      {{ transfer.pick_up_point.short_name }}
                      <img src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                      <span v-for="(point, index) in transfer.points" :key="point.id" class="arrange-popup__point">
                      {{ point.location.short_name }}
                      <img v-if="index !== transfer.points.length - 1" src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                    </span>
                    </div>
                    <div v-if="['arrival', 'departure', 'climbing', 'day_trip', 'safari'].includes(transfer.type.code)" class="arrange-popup__info">
                      <template v-if="transfer.type.code === 'arrival'">
                        <div class="arrival-popup__row">
                          <span>Pick-up date:</span>
                          <span>
                          {{ dateFormat(transfer.pick_up_date) }}<i class="arrival-popup__divider">|</i>{{ transfer.pick_up_time }}
                        </span>
                        </div>
                        <div class="arrival-popup__row">
                          <span>Pick-up point:</span>
                          <span>{{ transfer.pick_up_point.short_name }}</span>
                        </div>
                      </template>
                      <template v-if="transfer.type.code === 'arrival' || transfer.type.code === 'departure'">
                        <div class="arrange-popup__row">
                          <span>Transport details:</span>
                          <span>{{ transfer.transport_method.name }}<i class="arrange-popup__divider">|</i>{{ transfer.transport_company ? transfer.transport_company.name : '' }}<i v-if="transfer.transport_company" class="arrange-popup__divider">|</i>{{ transfer.transport_flight_number || '' }}<i v-if="transfer.transport_flight_number" class="arrange-popup__divider">|</i>{{ dateFormat(transfer.transport_date) }}<i v-if="transfer.transport_time" class="arrange-popup__divider">|</i>{{ transfer.transport_time }}</span>
                        </div>
                      </template>
                      <template v-if="transfer.type.code === 'climbing'">
                        <div class="arrange-popup__row">
                          <span>Climbing group:</span>
                          <router-link :to="{ name: 'climbing-groups-detail', params: { id: transfer.climbing_group.id } }" class="arrange-popup__link-bordered">{{ transfer.climbing_group.name }}</router-link>
                        </div>
                        <div v-if="transfer.climbing_group && transfer.climbing_group.meeting_time" class="arrange-popup__row">
                          <span>Meeting time:</span>
                          <span>{{ transfer.climbing_group.meeting_time }}</span>
                        </div>
                        <div v-if="transfer.climbing_group.starting_point && transfer.climbing_group.starting_point" class="arrange-popup__row">
                          <span>Starting point:</span>
                          <span>{{ transfer.climbing_group.starting_point.short_name }}</span>
                        </div>
                      </template>
                      <template v-if="transfer.type.code === 'day_trip'">
                        <div class="arrange-popup__row">
                          <span>Day trip group:</span>
                          <router-link :to="{ name: 'day-trips-groups-detail', params: { id: transfer.day_trip.id } }" class="arrange-popup__link-bordered">{{ transfer.day_trip.name }}</router-link>
                        </div>
                      </template>
                      <template v-if="transfer.type.code === 'safari'">
                        <div class="arrange-popup__row">
                          <span>Safari group:</span>
                          <router-link :to="{ name: 'safari-groups-detail', params: { id: transfer.safari_group.id } }" class="arrange-popup__link-bordered">{{ transfer.safari_group.name }}</router-link>
                        </div>
                      </template>
                    </div>
                    <div class="arrange-popup__row arrange-popup__row--4">
                      <app-form-group v-if="transfer.type.code !== 'arrival'" label="Pick-up date" class="form-group--no-indent" required>
                        <app-date-picker
                          v-model="transfer.pick_up_date"
                          placeholder="Tour start"
                          :clearable="false"
                          readonly
                        />
                      </app-form-group>
                      <app-form-group v-if="transfer.type.code !== 'arrival'" label="Pick-up time" label-for="reported_time" class="form-group--no-indent" required>
                        <app-input
                          v-model="transfer.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="00:00"
                          autocomplete="off"
                          id="reported_time"
                          name="reported_time"
                          @paste.native.prevent
                          readonly
                        />
                      </app-form-group>
                      <app-form-group label="Start date" class="form-group--no-indent" required>
                        <app-date-picker
                          v-model="transfer.start_date"
                          placeholder="Start date"
                          :clearable="false"
                          readonly
                        />
                      </app-form-group>
                      <app-form-group label="Start time" label-for="reported_time" class="form-group--no-indent" required>
                        <app-input
                          v-model="transfer.start_time"
                          v-mask="'99:99'"
                          placeholder="00:00"
                          autocomplete="off"
                          id="reported_time"
                          name="reported_time"
                          @paste.native.prevent
                          readonly
                        />
                      </app-form-group>
                    </div>
                    <div class="arrange-popup__row arrange-popup__row--2">
                      <app-form-group label="Finish date" class="form-group--no-indent" required>
                        <app-date-picker
                          v-model="transfer.estimated_finish_date"
                          placeholder="Finish start"
                          :clearable="false"
                          readonly
                        />
                      </app-form-group>
                      <app-form-group label="Finish time" label-for="reported_time" class="form-group--no-indent" required>
                        <app-input
                          v-model="transfer.estimated_finish_time"
                          v-mask="'99:99'"
                          placeholder="00:00"
                          autocomplete="off"
                          id="reported_time"
                          name="reported_time"
                          @paste.native.prevent
                          readonly
                        />
                      </app-form-group>
                    </div>
                    <app-form-group label="Notes" label-for="transfer_notes">
                      <app-textarea
                        v-model="transfer.notes"
                        rows="4"
                        placeholder="Write a notes"
                        id="transfer_notes"
                        readonly
                      />
                    </app-form-group>
                  </template>
                  <template #item-2>
                    <div class="arrange-popup__subtitle">Transport</div>
                    <div class="arrange-popup__part">
                      <div class="arrange-popup__block-title">
                        <span>Own cars</span>
                        <button @click="onAddOwnCar('transfer')" type="button">
                          <img src="@/assets/img/add-big-button-icon.svg" alt="">
                        </button>
                      </div>
                      <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                        <div v-for="(element, index) in transfer.own_cars" :key="`own_item_${index}`" class="transfer-sortable__item">
                          <div class="transfer-sortable__row transfer-sortable__row--pr">
                            <app-form-group class="form-group--no-indent" required>
                              <app-select
                                @input="onOwnCarSelected(element.car, index, 'transfer')"
                                v-model="element.car"
                                :options="cars_options"
                                :clearable="false"
                                label="plate_number"
                                placeholder="Select car"
                                :error="$v.transfer.own_cars.$each[index].car.$error"
                              />
                              <template #error>
                                <div v-if="$v.transfer.own_cars.$each[index].car.$dirty && !$v.transfer.own_cars.$each[index].car.required">Required field</div>
                              </template>
                            </app-form-group>
                            <app-form-group class="form-group--no-indent" required>
                              <app-select
                                v-model="element.driver"
                                :options="drivers_options"
                                :clearable="false"
                                label="full_name"
                                placeholder="Enter driver"
                                :erorr="$v.transfer.own_cars.$each[index].driver.$error"
                              />
                              <template #error>
                                <div v-if="$v.transfer.own_cars.$each[index].driver.$dirty && !$v.transfer.own_cars.$each[index].driver.required">Required field</div>
                              </template>
                            </app-form-group>
                            <button
                              @click="onRemoveOwnItem(index, 'transfer')"
                              class="transfer-sortable__close"
                              type="button"
                            >
                              <img src="@/assets/img/delete-transfer.svg" alt="">
                            </button>
                          </div>
                          <div class="transfer-sortable__row">
                            <app-cells :indent="false">
                              Driver confirmed: <app-switcher v-model="element.driver_confirmed" :readonly="!element.driver" />
                            </app-cells>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="arrange-popup__part">
                      <div class="arrange-popup__block-title">
                        <span>Rental</span>
                        <button @click="onAddRental('transfer')" type="button">
                          <img src="@/assets/img/add-big-button-icon.svg" alt="">
                        </button>
                      </div>
                      <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                        <div v-for="(element, index) in transfer.rental_cars" :key="`rental_item_${index}`" class="transfer-sortable__item">
                          <div class="transfer-sortable__row transfer-sortable__row--pr">
                            <app-form-group class="form-group--no-indent" required>
                              <app-select
                                @input="onRentalCompanySelected(element.rental_company, index)"
                                v-model="element.rental_company"
                                :options="company_options"
                                :clearable="false"
                                placeholder="Select company"
                                :error="$v.transfer.rental_cars.$each[index].rental_company.$error"
                              />
                              <template #error>
                                <div v-if="$v.transfer.rental_cars.$each[index].rental_company.$dirty && !$v.transfer.rental_cars.$each[index].rental_company.required">Required field</div>
                              </template>
                            </app-form-group>
                            <app-form-group class="form-group--no-indent" required>
                              <app-select
                                @input="onRentalCarModelSelected(element.car_model.id, index, 'transfer')"
                                v-model="element.car_model"
                                :options="rental_options[index].models_options"
                                :clearable="false"
                                placeholder="Select car model"
                                :readonly="!element.rental_company"
                                :error="$v.transfer.rental_cars.$each[index].car_model.$error"
                              />
                              <template #error>
                                <div v-if="$v.transfer.rental_cars.$each[index].car_model.$dirty && !$v.transfer.rental_cars.$each[index].car_model.required">Required field</div>
                              </template>
                            </app-form-group>
                          </div>
                          <div class="transfer-sortable__row transfer-sortable__row--mix transfer-sortable__row--pr">
                            <app-form-group class="form-group--no-indent" required>
                              <app-select
                                @input="onRentalCarSelected(element.car, index, 'transfer')"
                                v-model="element.car"
                                :options="rental_options[index].cars_options"
                                :clearable="false"
                                label="plate_number"
                                placeholder="Select car"
                                :readonly="!element.car_model"
                              />
                            </app-form-group>
                            <app-form-group class="form-group--no-indent" required>
                              <app-select
                                v-model="element.driver"
                                :options="rental_options[index].drivers_options"
                                :clearable="false"
                                label="full_name"
                                placeholder="Select driver"
                                :readonly="!element.car"
                              />
                            </app-form-group>
                            <div class="arrange-popup__cost">
                              <span>Price (TSh):</span>
                              <app-form-group class="form-group--no-indent">
                                <app-input
                                  v-model.number="element.rental_cost"
                                  type="number"
                                  placeholder="0"
                                  id="cost"
                                  name="cost"
                                  class="input--100"
                                  :error="$v.transfer.rental_cars.$each[index].rental_cost.$error"
                                />
                                <template #error>
                                  <div v-if="$v.transfer.rental_cars.$each[index].rental_cost.$dirty && !$v.transfer.rental_cars.$each[index].rental_cost.required">Required field</div>
                                </template>
                              </app-form-group>
                            </div>
                          </div>
                          <button
                            @click="onRemoveRentalItem(index, 'transfer')"
                            class="transfer-sortable__close"
                            type="button"
                          >
                            <img src="@/assets/img/delete-transfer.svg" alt="">
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="arrange-popup__part">
                      <div class="arrange-popup__block-title">
                        <span>Taxi</span>
                        <button @click="onAddTaxi('transfer')" type="button">
                          <img src="@/assets/img/add-big-button-icon.svg" alt="">
                        </button>
                      </div>
                      <div class="transfer-sortable transfer-sortable--own transfer-sortable--full">
                        <div v-for="(element, index) in transfer.taxi" :key="`taxi_item_${index}`" class="transfer-sortable__item">
                          <div class="transfer-sortable__row transfer-sortable__row--mix transfer-sortable__row--pr">
                            <app-form-group class="form-group--no-indent" required>
                              <app-select
                                v-model="element.taxi_driver"
                                :options="taxi_options"
                                :clearable="false"
                                label="full_name"
                                placeholder="Select taxi"
                                :error="$v.transfer.taxi.$each[index].taxi_driver.$error"
                              />
                              <template #error>
                                <div v-if="$v.transfer.taxi.$each[index].taxi_driver.$dirty && !$v.transfer.taxi.$each[index].taxi_driver.required">Required field</div>
                              </template>
                            </app-form-group>
                            <span v-if="element.taxi_driver">
                              {{ element.taxi_driver.car_model.name }} ({{ element.taxi_driver.plate_number }})
                            </span>
                            <div class="arrange-popup__cost">
                              <span>Price (TSh):</span>
                              <app-form-group class="form-group--no-indent">
                                <app-input
                                  v-model.number="element.cost"
                                  type="number"
                                  placeholder="0"
                                  id="cost"
                                  name="cost"
                                  class="input--100"
                                  :error="$v.transfer.taxi.$each[index].cost.$error"
                                />
                                <template #error>
                                  <div v-if="$v.transfer.taxi.$each[index].cost.$dirty && !$v.transfer.taxi.$each[index].cost.required">Required field</div>
                                </template>
                              </app-form-group>
                            </div>
                            <button
                              @click="onRemoveTaxiItem(index, 'transfer')"
                              class="transfer-sortable__close"
                              type="button"
                            >
                              <img src="@/assets/img/delete-transfer.svg" alt="">
                            </button>
                          </div>
                          <div class="transfer-sortable__row">
                            <app-cells :indent="false">
                              Driver confirmed: <app-switcher v-model="element.driver_confirmed" :readonly="!element.taxi_driver" />
                            </app-cells>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </app-grid>
              </div>
              <app-cells position="center" :indent="false">
                <app-button
                  :disabled="$v.transfer.$error || (!transfer.own_cars.length && !transfer.rental_cars.length && !transfer.taxi.length)"
                  type="submit"
                  ref="submit"
                >
                  Arrange transfer
                </app-button>
              </app-cells>
            </form>
          </div>
        </div>
      </modal>
    </template>
  </div>
</template>

<script>
import {
  getCarManagementCars,
  getEmployeesListSearch,
  getGoogleSearch,
  getTransfersDatesList,
  getTransfersRentalCompanyCarsList,
  getTransfersRentalCompanyDriversList,
  getTransfersRentalCompanyList,
  getTransfersTaxiDriversList,
  patchTransfers,
  postLocation,
  postTransferArchive
} from '@/http'
import TransfersBlocks from '@/views/transfer/transfers/TransfersBlocks'
import debounce from 'lodash/debounce'
import { helpers, required } from 'vuelidate/lib/validators'
import draggable from 'vuedraggable'
import { format, parse } from 'date-fns'
const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'TransfersArchive',
  components: { draggable, TransfersBlocks },
  data() {
    return {
      is_loaded: false,
      archive_transfers: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_length: 0,
      filter_dates: null,
      date_picker_error: false,
      date_range: [],
      search: '',
      filter_car: '',
      filter_driver: '',
      cars_options: [],
      drivers_options: [],
      create_staff_cars_form: {
        points: [{ location: null }],
        own_cars: [],
        rental_cars: [],
        taxi: [],
      },
      location_options: [],
      company_options: [],
      rental_cars_options: [],
      rental_drivers_options: [],
      rental_options: [],
      taxi_options: [],
      transfer: null,
    }
  },
  validations: {
    create_staff_cars_form: {
      name: { required },
      points: {
        $each: {
          location: { required },
        }
      },
      other_pax: { required },
      pick_up_date: { required },
      pick_up_time: {
        required,
        timeRegex
      },
      pick_up_point: { required },
      own_cars: {
        $each: {
          car: { required },
          driver: { required },
        }
      },
      taxi: {
        $each: {
          taxi_driver: { required },
          cost: { required },
        }
      },
      rental_cars: {
        $each: {
          rental_company: { required },
          car_model: { required },
          rental_cost: { required },
        }
      },
      notes: { required },
    },
    transfer: {
      own_cars: {
        $each: {
          car: { required },
          driver: { required },
        }
      },
      taxi: {
        $each: {
          taxi_driver: { required },
          cost: { required },
        }
      },
      rental_cars: {
        $each: {
          rental_company: { required },
          car_model: { required },
          rental_cost: { required },
        }
      }
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'destination',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
  },
  created() {
    this.fetchItems()
    getCarManagementCars({ available_for_transfers: true }).then(res => { this.cars_options = res.data })
    getEmployeesListSearch({ position: 'driver', employment_status: 'working' })
      .then(res => { this.drivers_options = res.data })
    getTransfersTaxiDriversList().then(res => { this.taxi_options = res.data })
    getTransfersRentalCompanyList().then(res => { this.company_options = res.data })
  },
  methods: {
    onCheckArrangeForm() {
      this.$v.transfer.$touch()
      if (this.$v.transfer.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      patchTransfers(this.transfer.id, this.normalizeArrangeForm())
        .finally(() => { this.$refs.submit.preload = false })
        .then(() => {
          this.$modal.hide('arrange-popup')
          this.fetchItems()
        })
    },
    normalizeArrangeForm() {
      let own_cars = [ ...this.transfer.own_cars ]
      let taxi = [ ...this.transfer.taxi ]
      let rental_cars = [ ...this.transfer.rental_cars ]

      if (own_cars.length) own_cars = own_cars.map(item => ({ car: item.car.id, driver: item.driver.id, id: item.id, driver_confirmed: item.driver_confirmed }))
      if (taxi.length) taxi = taxi.map(item => ({ taxi_driver: item.taxi_driver.id, cost: item.cost, id: item.id, driver_confirmed: item.driver_confirmed }))
      if (rental_cars.length) {
        rental_cars = rental_cars.map(item => ({
          rental_company: item.rental_company.id,
          car_model: item.car_model.id,
          id: item.id,
          rental_cost: item.rental_cost,
          driver: item.driver ? item.driver.id : null,
          car: item.car ? item.car.id : null,
        }))
        rental_cars.forEach(item => {
          if (!item.driver) delete item.driver
          if (!item.car) delete item.car
        })
      }
      return { own_cars, taxi, rental_cars }
    },
    onArrangePopupOpen(transfer) {
      this.$v.transfer.$reset()
      this.transfer = { ...transfer }
      if (this.transfer.rental_cars.length) {
        this.rental_options = this.transfer.rental_cars.map(item => ({
          models_options: this.company_options.find(company => company.id === item.rental_company.id).car_models,
          cars_options: item.rental_company.cars,
          drivers_options: item.rental_company.drivers
        }))
      }
      this.$modal.show('arrange-popup')
    },
    onCheckCreateStaffCarsForm() {
      this.$v.create_staff_cars_form.$touch()
      if (this.$v.create_staff_cars_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendCreateStaffCarsForm()
      }
    },
    sendCreateStaffCarsForm() {
      this.$refs.create_staff_cars_submit.preload = true
      postTransferArchive(this.normalizeCreateStaffCarsForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer requested',
          })
          this.$modal.hide('create-staff-cars-modal')
          this.fetchItems()
        })
        .catch(() => { this.$refs.create_staff_cars_submit.preload = false })
    },
    normalizeCreateStaffCarsForm() {
      const form = {}
      let own_cars = [ ...this.create_staff_cars_form.own_cars ]
      let taxi = [ ...this.create_staff_cars_form.taxi ]
      let rental_cars = [ ...this.create_staff_cars_form.rental_cars ]

      form.points = [ ...this.create_staff_cars_form.points ].map((item, index) => ({ location: item.location.id, sort: index }))
      form.name = this.create_staff_cars_form.name
      form.other_pax = this.create_staff_cars_form.other_pax
      form.pick_up_date = this.create_staff_cars_form.pick_up_date
      form.pick_up_time = this.create_staff_cars_form.pick_up_time
      form.pick_up_point = this.create_staff_cars_form.pick_up_point.id
      form.notes = this.create_staff_cars_form.notes

      if (own_cars.length) own_cars = own_cars.map(item => ({ car: item.car.id, driver: item.driver.id, id: item.id, driver_confirmed: item.driver_confirmed }))
      if (taxi.length) taxi = taxi.map(item => ({ taxi_driver: item.taxi_driver.id, cost: item.cost, id: item.id, driver_confirmed: item.driver_confirmed }))
      if (rental_cars.length) {
        rental_cars = rental_cars.map(item => ({
          rental_company: item.rental_company.id,
          car_model: item.car_model.id,
          id: item.id,
          rental_cost: item.rental_cost,
          driver: item.driver ? item.driver.id : null,
          car: item.car ? item.car.id : null,
        }))
        rental_cars.forEach(item => {
          if (!item.driver) delete item.driver
          if (!item.car) delete item.car
        })
      }

      return { ...form, own_cars, taxi, rental_cars }
    },
    onRangeChange([from, to] = date) {
      this.is_loaded = false
      getTransfersDatesList({
        page: this.pagination.page,
        page_size: 40,
        category: 'archive',
        compact: true,
        group_by: 'pick_up_date',
        ordering: '-pick_up_date,-pick_up_time',
        range_type: 'day',
        from_date: from,
        to_date: to,
        search: this.search,
        own_cars: this.filter_car,
        driver: this.filter_driver
      })
        .then(res => {
          this.archive_transfers = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_requested_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.is_loaded = true
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    fetchItems() {
      this.is_loaded = false
      getTransfersDatesList({
        page: this.pagination.page,
        page_size: 40,
        category: 'archive',
        compact: true,
        group_by: 'pick_up_date',
        ordering: '-pick_up_date,-pick_up_time',
        range_type: 'day',
        from_date: this?.date_range[0],
        to_date: this?.date_range[1],
        search: this.search,
        own_cars: this.filter_car,
        driver: this.filter_driver
      })
        .then(res => {
          this.archive_transfers = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_requested_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.is_loaded = true
        })
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchItems()
      } else this.date_picker_error = true
    },
    onTransferSearch() {
      this.date_range = []
      this.filter_car = null
      this.filter_driver = null
      this.searchTransfer(this)
    },
    searchTransfer: debounce(vm => {
      vm.fetchItems()
    }, 700),
    onStaffPickUpPointSelected({ name, place_id }, type, ref) {
      this.$refs[ref].preload = true
      postLocation({ name, place_id }).then(res => {
        this[type].pick_up_point = res.data
        this.$refs[ref].preload = false
      })
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          loading(false)
          vm.location_options = response.data
        })
      }
    }, 350),
    onStaffLocationSelected({ name, place_id }, index, type, ref) {
      this.$refs[ref].preload = true
      postLocation({ name, place_id }).then(res => {
        this[type].points[index].location = res.data
        this.$refs[ref].preload = false
      })
    },
    onRemoveStaffDestination(index, type) {
      this[type].points.splice(index, 1)
      this.$v[type].points.$touch()
    },
    onAddStaffDestination(type) {
      this[type].points.push({ location: null })
    },
    onAddOwnCar(type) {
      this[type].own_cars.push({ car: null, driver: null })
    },
    onOwnCarSelected(car, index, type) {
      if (car.driver) this[type].own_cars[index].driver = car.driver
      else this[type].own_cars[index].driver = null
    },
    onRemoveOwnItem(index, type) {
      this[type].own_cars.splice(index, 1)
    },
    onAddRental(type) {
      this.rental_options.push({ models_options: [], cars_options: [], drivers_options: [] })
      this[type].rental_cars.push({ rental_company: null, car_model: null, car: null, driver: null })
    },
    onRentalCompanySelected(company, index) {
      getTransfersRentalCompanyDriversList(company.id).then(res => {
        this.rental_options[index].drivers_options = res.data
        this.rental_options[index].models_options = company.car_models
      })
    },
    onRentalCarModelSelected(car_model_id, index, type) {
      this[type].rental_cars[index].car = null
      this[type].rental_cars[index].driver = null
      getTransfersRentalCompanyCarsList(this[type].rental_cars[index].rental_company.id, { car_model: car_model_id })
        .then(res => { this.rental_options[index].cars_options = res.data })
    },
    onRentalCarSelected(car, index, type) {
      if (car.driver) this[type].rental_cars[index].driver = car.driver
      else this[type].rental_cars[index].driver = null
    },
    onRemoveRentalItem(index, type) {
      this[type].rental_cars.splice(index, 1)
      this.rental_options.splice(index, 1)
    },
    onAddTaxi(type) {
      this[type].taxi.push({ taxi_driver: null })
    },
    onRemoveTaxiItem(index, type) {
      this[type].taxi.splice(index, 1)
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
  }
}
</script>
<style lang="sass" scoped>
.transfer-list
  max-width: 1100px

.sticky-title
  position: sticky
  top: 0
  z-index: 20
  padding: 3px 0
  background-color: #fff

.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
